module.exports = __webpack_public_path__ + "img/20211021-benovelty-dbs-xero.6c9112e0.jpg";